import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { baseStyles } from '../styles/shared.js';
import type { ViewDefinition } from '../api/types.js';

// ---------------------------------------------------------------------------
// <sysml-view-selector> — View filter dropdown
// ---------------------------------------------------------------------------

@customElement('sysml-view-selector')
export class SysmlViewSelector extends LitElement {
  static override styles = [
    baseStyles,
    css`
      :host {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-2);
      }
      label {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        white-space: nowrap;
      }
      select {
        font-family: var(--r5-font-sans);
        font-size: var(--r5-text-xs);
        padding: var(--r5-space-1) var(--r5-space-2);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-sm);
        background: var(--r5-surface);
        color: var(--r5-text);
        cursor: pointer;
        max-width: 200px;
      }
      select:focus {
        outline: 2px solid var(--r5-primary);
        outline-offset: -1px;
      }
    `,
  ];

  @property({ type: Array }) views: ViewDefinition[] = [];
  @property({ attribute: 'active-view-id' }) activeViewId: string | null = null;

  override render() {
    return html`
      <label for="view-select">View:</label>
      <select id="view-select" @change=${this._onChange}>
        <option value="" ?selected=${!this.activeViewId}>All elements</option>
        ${this.views.map(
          (v) => html`
            <option value=${v.id} ?selected=${this.activeViewId === v.id}>
              ${v.name}
            </option>
          `,
        )}
      </select>
    `;
  }

  private _onChange(e: Event): void {
    const select = e.target as HTMLSelectElement;
    const viewId = select.value || null;
    this.dispatchEvent(
      new CustomEvent('view-change', {
        detail: { viewId },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sysml-view-selector': SysmlViewSelector;
  }
}
